import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@htx/environment';
import { RepresentativeChangeRequest, RepresentativeChangeComment } from './representative-change.model';

@Injectable({
  providedIn: 'root'
})
export class RepresentativeChangeService {

  private httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.backendUrl}/organizations/representative-changes`;

  createRequest(newMemberId: string, reasoning: string, document: File): Observable<RepresentativeChangeRequest> {
    const formData = new FormData();
    formData.append('newMemberId', newMemberId);
    if (reasoning) {
      formData.append('reasoning', reasoning);
    }
    formData.append('document', document);
    return this.httpClient.post<RepresentativeChangeRequest>(this.baseUrl, formData);
  }

  findAll(): Observable<RepresentativeChangeRequest[]> {
    return this.httpClient.get<RepresentativeChangeRequest[]>(this.baseUrl);
  }

  getDetailsById(id: string): Observable<RepresentativeChangeRequest> {
    return this.httpClient.get<RepresentativeChangeRequest>(`${this.baseUrl}/${id}`);
  }

  approve(id: string, reasoning: string): Observable<void> {
    return this.httpClient.put<void>(`${this.baseUrl}/${id}/approve`, { reasoning });
  }

  reject(id: string, reasoning: string): Observable<void> {
    return this.httpClient.put<void>(`${this.baseUrl}/${id}/reject`, { reasoning });
  }

  getDocument(id: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/${id}/document`, {
      responseType: 'blob'
    });
  }

  getComments(id: string): Observable<RepresentativeChangeComment[]> {
    return this.httpClient.get<RepresentativeChangeComment[]>(`${this.baseUrl}/${id}/comments`);
  }

  addComment(id: string, body: { text: string }): Observable<RepresentativeChangeComment> {
    return this.httpClient.post<RepresentativeChangeComment>(`${this.baseUrl}/${id}/comments`, body);
  }
}
